export function favOptions(option, id='') {
    if (!localStorage.getItem("Favorite_movies")) {
        localStorage.setItem("Favorite_movies", JSON.stringify({}));
    }

    switch (option) {
        case "GET":
            return JSON.parse(localStorage.getItem("Favorite_movies"));
        case "SET":
            return localStorage.setItem("Favorite_movies", JSON.stringify(id));
    }
}

// get method
// set method




